const api = process.env.REACT_APP_API_URL;

export const urls = {
   userCountries: `${api}GetUserCountries?`,
   scenarioStatus: `${api}ApprovalScenario/GetScenarioStatus`,
   periods: `${api}ApprovalScenario/GetPeriods`,
   scenariosForApproval: `${api}ApprovalScenario/GetScenarioforApproval`,
   scenarioDetails: `${api}ApprovalScenario/GetScenarioDetails?`,
   approveScenario: `${api}Approval/ApproveScenario`,
   rejectScenario: `${api}Approval/RejectScenario`,
   approveMultile: `${api}Approval/ApproveScenarioMultiple`,
   rejectMultile: `${api}Approval/RejectScenarioMultiple`,
   Upload : `${api}Approve/Upload`,
   Downloadfile: `${api}Define/DownloadFile?`,
   ScenarioHistory: `${api}ApprovalScenario/GetScenarioHistory?`,
   ScenarioModificationDetails:`${api}ApprovalScenario/GetScenarioModificationDetails?`,

};

export function getScenariosForApprovalTable(data) {
   const rows = getScenariosForApprovalRows(data);
   for(let i = 0; i < rows.length; i++) {
      rows[i] = getApproveStatus(rows[i]);
   }
   return { rows };
}

function getApprovalActionFlags(statusValue) {
   let scenarioStatus = (statusValue || "").toLowerCase();
   const logedUser = JSON.parse(localStorage.getItem("data"));
   let canApproveReject = false;
   let canEdit = false;

   if (logedUser.isAnalyst == true) {
     if (scenarioStatus == "submitted" || scenarioStatus == "locally approved") {
       canApproveReject = false;
       canEdit = false;
     }
   } else {
     if (scenarioStatus == "approved" || scenarioStatus == "rejected") {
       canApproveReject = false;
       canEdit = true;
     } else {
       if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
         if (scenarioStatus == "submitted" || scenarioStatus == "locally approved") {
           canApproveReject = true;
           canEdit = false;
         }
       } else if (!logedUser.isHQUser) {
         if (scenarioStatus == "submitted") {
           canApproveReject = true;
           canEdit = false;
         } else if (scenarioStatus == "locally approved") {
           canApproveReject = false;
           canEdit = false;
         }
       }
     }
   }

   return { canApproveReject, canEdit };
}

function  getApproveStatus (item){
   const flags = getApprovalActionFlags(item.scenarioStatus);
   item['canApproveReject'] = flags.canApproveReject;
   item['canEdit'] = flags.canEdit;
  return item;
 }

function getScenariosForApprovalRows(data) {
   const rows = [];
   data.forEach((item) => {
      rows.push({
         id: item.scenarioID,
         scenarioName: item.scenarioName,
         criticality : item.criticality,
         countryID: item.countryID,
         scenarioStatus: item.scenarioStatus,
         updatedDate: item.updatedDate,
         updatedBy: item.updatedBy,
         isEdit: item.isEdit,
      });
   });
   return rows;
}

export function getProductNames(products) {
   if (products) {
      const names = products.map((product) => {
         return product.product.name;
      });
      return names;
   }
   return [];
}


export function getProductGroupNames(productGroup) {
   if (productGroup) {
      const names = productGroup.map((productGroup) => {
         return productGroup.productGroup.productGroupName;
      });
      return names;
   }
   return [];
}

export function getCustomerGroupNames(customerGroups) {
   if (customerGroups) {
      const names = customerGroups.map((customerGroup) => {
         return customerGroup.customerGroup.customerGroupName;
      });
      return names;
   }
   return [];
}

export function getCustomerNames(customers) {
   if (customers) {
      const names = customers.map((customer) => {
         return customer.customer.customerName;
      });
      return names;
   }
   return [];
}

export function getDSNames(list) {
   if(list) {
      const names = list.map((item) => {
         return item.dataSourceName;
      });
      return names;
   }
   return [];
}

function pickField(obj, ...keys) {
	for (const k of keys) {
		if (obj != null && obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
			return obj[k];
		}
	}
	return "";
}

export function getModificationColor(isActive) {
	const value = Number(isActive);
	if (value === 1) return "#2e7d32";
	if (value === -1) return "#c62828";
	return "#000000";
}

function parseIsActive(item) {
	return Number(pickField(item, "isActive", "IsActive"));
}

function toDisplayNameOnly(value) {
	const str = String(value || "").trim();
	if (!str) return "";
	const hashIdx = str.indexOf("#");
	if (hashIdx >= 0) return str.substring(0, hashIdx).trim();
	return str;
}

export function mapProductGroupModifications(list) {
	if (!list || !Array.isArray(list)) return [];
	return list.map((item, index) => {
		const name = toDisplayNameOnly(pickField(item, "packGroup", "PackGroup"));
		const number = String(pickField(item, "packGroupID", "PackGroupID") || index);
		return {
			id: pickField(item, "packGroupID", "PackGroupID") || index,
			line: name,
			name: name.toLowerCase(),
			number: number.toLowerCase(),
			isActive: parseIsActive(item),
		};
	});
}

export function mapSKUModifications(list) {
	if (!list || !Array.isArray(list)) return [];
	return list.map((item, index) => {
		const sku = pickField(item, "sku", "SKU");
		const number = pickField(item, "skuNumber", "SKUNumber");
		let line = sku;
		if (!line.includes("|") && sku && number) {
			const parts = String(sku).split("#");
			if (parts.length > 1) line = sku;
			else line = `${sku}#${number}`;
		} else if (!line && number) {
			line = number;
		}
		const namePart = String(line).split("|")[0] || line;
		return {
			id: pickField(item, "skuID", "SKUID") || index,
			line,
			name: namePart.toLowerCase(),
			number: String(number || "").toLowerCase(),
			isActive: parseIsActive(item),
		};
	});
}

export function mapCustomerGroupModifications(list) {
	if (!list || !Array.isArray(list)) return [];
	return list.map((item, index) => {
		const name = toDisplayNameOnly(
			pickField(item, "customerGroup", "CustomerGroup")
		);
		const number = String(
			pickField(item, "customerGroupID", "CustomerGroupID") || index
		);
		return {
			id: pickField(item, "customerGroupID", "CustomerGroupID") || index,
			line: name,
			name: name.toLowerCase(),
			number: number.toLowerCase(),
			isActive: parseIsActive(item),
		};
	});
}

export function mapCustomerModifications(list) {
	if (!list || !Array.isArray(list)) return [];
	return list.map((item, index) => {
		const name = pickField(item, "customer", "Customer");
		const number = pickField(item, "customerNumber", "CustomerNumber");
		let line = name;
		if (name && number && !String(name).includes("|")) {
			line = `${name}|${number}#${number}`;
		} else if (name && number) {
			line = name;
		} else if (number) {
			line = number;
		}
		const namePart = String(line).split("|")[0] || line;
		return {
			id: pickField(item, "customerID", "CustomerID") || index,
			line,
			name: namePart.toLowerCase(),
			number: String(number || "").toLowerCase(),
			isActive: parseIsActive(item),
		};
	});
}

function getLatestScenarioModificationId(history) {
   let latestId = null;
   let maxModId = -Infinity;

   for (const item of history) {
      const modId = item.scenarioModificationID ?? item.ScenarioModificationID;
      if (modId != null && modId > maxModId) {
         maxModId = modId;
         latestId = modId;
      }
   }

   if (latestId != null) {
      return latestId;
   }

   let maxSubmissionNum = -Infinity;
   for (const item of history) {
      const submissionNumber = item.submissionNumber ?? item.SubmissionNumber ?? "";
      const match = String(submissionNumber).match(/(\d+)\s*$/);
      const num = match ? parseInt(match[1], 10) : -Infinity;
      const modId = item.scenarioModificationID ?? item.ScenarioModificationID;
      if (num > maxSubmissionNum && modId != null) {
         maxSubmissionNum = num;
         latestId = modId;
      }
   }

   return latestId;
}

export function getScenarioHistoryRows(history) {
   if (!history || !Array.isArray(history)) {
      return [];
   }
   const latestModificationId = getLatestScenarioModificationId(history);
   return history.map((item, index) => {
      const status = item.status ?? item.Status ?? "";
      const flags = getApprovalActionFlags(status);
      const scenarioModificationID =
         item.scenarioModificationID ?? item.ScenarioModificationID;
      return {
         id: scenarioModificationID ?? index,
         submissionNumber: item.submissionNumber ?? item.SubmissionNumber ?? "",
         status,
         modifiedDate: item.modifiedDate ?? item.ModifiedDate ?? "",
         modifiedBy: item.modifiedBy ?? item.ModifiedBy ?? "",
         scenarioModificationID,
         scenarioID: item.scenarioID ?? item.ScenarioID,
         canApproveReject: flags.canApproveReject,
         canEdit: flags.canEdit,
         isLatestSubmission: scenarioModificationID === latestModificationId,
      };
   });
}
